import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";
import { IStockMovementFilter } from "../models/filters/stockMovementFilter";
import { IStockMovementForm } from "../models/forms/stockMovementForm";
import { IStockMovementPDTO } from "../models/dtos/stockMovementPDTO";
import { apiCallWithAuth } from "../helper/apiManager";
import { IArticleStockUnityMovementForm } from "../models/forms/articleForm";
import { resolveAxiosErrorMessage } from "../helper/apiError";

export default class StockMovementService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/StockMovement";

    protected static override  getUrlFilter<F extends IStockMovementFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.codeStockId != undefined)
                url += `&CodeStockId=${filter.codeStockId}`;
            if(filter.articleId != undefined)
                url += `&ArticleId=${filter.articleId}`;
            if(filter.centerId != undefined)
                url += `&CenterId=${filter.centerId}`;
            if(filter.unityId != undefined)
                url += `&UnityId=${filter.unityId}`;
            if(filter.way != undefined)
                url += `&Way=${filter.way}`;
            if(filter.dateDebut != undefined)
                url += `&DateDebut=${filter.dateDebut}`;
            if(filter.dateFin != undefined)
                url += `&DateFin=${filter.dateFin}`;
            if(filter.dateProductionDebut != undefined)
                url += `&DateProductionDebut=${filter.dateProductionDebut}`;
            if(filter.dateProductionFin != undefined)
                url += `&DateProductionFin=${filter.dateProductionFin}`;
            if(filter.animalSearch != undefined)
                url += `&AnimalSearch=${encodeURIComponent(filter.animalSearch)}`;
            if(filter.lotNumber != undefined)
                url += `&LotNumber=${encodeURIComponent(filter.lotNumber)}`;
            if(filter.bordereauSearch != undefined)
                url += `&BordereauSearch=${encodeURIComponent(filter.bordereauSearch)}`;
            if(filter.movementTypeIds?.length)
                filter.movementTypeIds.forEach(id => url += `&MovementTypeIds=${id}`);
            if(filter.codeStockIds?.length)
                filter.codeStockIds.forEach(id => url += `&CodeStockIds=${id}`);
        }

        return url;
    }

    /**
     * Insertion manuelle d'une dose (réception externe / ajout hétéro). Code-based :
     * Article / StockUnity / Stock peuvent ne pas exister, le backend les crée via
     * CreateWithUpsertAsync.
     */
    public static async stockMovement(form: IArticleStockUnityMovementForm) {
        try {
            let result = await apiCallWithAuth(this.mainUrl + "/articlestockmovement", "post", form);
            return this.ReturnObject(result);
        } catch (err) {
            return this.ReturnError(err);
        }
    }

    public static async cancelMovement(movementId: number, agentId?: number, commentaire?: string) {
        try {
            let result = await apiCallWithAuth(`${this.mainUrl}/${movementId}/cancel`, "post", { agentId, commentaire });
            return this.ReturnObject(result);
        } catch (err) {
            return this.ReturnError(err);
        }
    }

    public static async destroyBatch(centerCode: string, items: { stockId: number; quantity: number }[], commentaire?: string, agentId?: number) {
        try {
            let result = await apiCallWithAuth(this.mainUrl + "/destroy-batch", "post", { centerCode, items, commentaire, agentId });
            return this.ReturnObject(result);
        } catch (err: any) {
            // ReturnError ne conserve que le message axios (« Request failed with status code 400 ») :
            // le motif metier du refus est perdu et l'ecran n'affiche qu'une erreur generique.
            // Depuis 0028455 le serveur refuse une destruction superieure au stock disponible — donc
            // typiquement une ligne deja detruite depuis un autre poste. L'operateur doit savoir que
            // c'est ca, sinon il reessaie. Meme remontee que DispatchManufactoringService.orientHetero.
            const result: any = this.ReturnError(err);
            result.businessCode = err?.response?.data?.code ?? null;
            result.businessMessage = resolveAxiosErrorMessage(err);
            return result;
        }
    }

    public static async transferBatch(sourceCenterId: number, destinationCenterId: number, sourceCodeStockId: number, destinationCodeStockId: number, items: { stockId: number; quantity: number }[], commentaire?: string, agentId?: number) {
        try {
            let result = await apiCallWithAuth(this.mainUrl + "/transfer-batch", "post", { sourceCenterId, destinationCenterId, sourceCodeStockId, destinationCodeStockId, items, commentaire, agentId });
            return this.ReturnObject(result);
        } catch (err) {
            return this.ReturnError(err);
        }
    }

    public static async adjustStock(stockId: number, modeAutoConsommation: boolean, quantity: number, motifId: number, commentaire?: string, agentId?: number) {
        try {
            let result = await apiCallWithAuth(this.mainUrl + "/adjust", "post", { stockId, modeAutoConsommation, quantity, motifId, commentaire, agentId });
            return this.ReturnObject(result);
        } catch (err) {
            return this.ReturnError(err);
        }
    }

    public static override toDTO(obj:IStockMovementForm):IStockMovementPDTO {
        const dto = super.toDTO(obj) as IStockMovementPDTO;
        return dto;
    }
}